import axios from "axios";
import API from "../api/axios.js";
import { Airplay } from "lucide-react";


export const getReview = async (applicationId, currentUserId) => {
    const response = await API.get(
        `/application/${applicationId}/review`,
        {
            params: {
                currentUserId,
            },
        }
    );

    return response.data;
};

export const saveEvaluation = async (applicationId, data) => {
    await API.put(`/application/${applicationId}/evaluation`, data);
};

export const verifyApplication = async (applicationId) => {
    await API.post(`/application/${applicationId}/verify`);
};

export const submitEvaluation = async (applicationId) => {
    await API.post(`/application/${applicationId}/submit`);
};





export const getAdminAwardRanking = async (currentUserId) => {
    const response = await API.get(
        `/application-review/admin-ranking`,
        {
            params: {
                currentUserId,
            },
        }
    );

    return response.data;
};

export const getSuperAdminAwardRanking = async (currentUserId) => {
    const response = await API.get(
        `/application-review/superadmin-ranking`,
        {
            params: {
                currentUserId,
            },
        }
    );

    return response.data;
};